<template>
  <sky-charts ref="chart"
              :config="chartConfig"
              legendPosition="right"
              :showTitle="false"
              :showShadow="false"
              :chartData="data"
              :extend="extend">
    <div slot="header"
         class="header">
      <div class="title">性别</div>
      <div class="select">
        <el-select v-model="selectVal"
                   placeholder="展示占比"
                   size="mini"
                   @change="change">
          <el-option v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
  </sky-charts>
</template>

<script>
import mixins from "./ga_mixins";
import { audienceReportRatio } from "@/common/dictionary.js";
import filters from "@/mixins/filters.js";
export default {
  name: "fb-series-pie",
  mixins: [mixins],
  components: {},
  data () {
    let that = this;
    const mapping = {
      male: "男性",
      female: '女性',
      unknown: '未知'
    }
    return {
      selectVal: "impressions",
      options: audienceReportRatio,
      selectName: "展示占比",
      extend: {
        series: {
          type: 'pie',
          label: {
            formatter (val) {
              return mapping[val.name];
            }
          },
          tooltip: {
            formatter (val) {
              let name = that.selectName.substring(0, 2)
              let format = name === '消耗' ? 'rmb' : 'thousands'
              let nameMap = { '展示': '展示次数', '消耗': '消耗', '覆盖': '覆盖人数' }
              return `
                ${mapping[val.name]}</br>
                ${that.selectName}：${val.value}%</br>
                ${nameMap[name]}：${filters.filters[format](that.data[val.dataIndex][that.selectVal])}
                `
            }
          },
        },
        color: ['#36CBCB', '#3DA1FF', '#975FE4',]
      },
      chartConfig: {
        height: "300px",
        type: "vePie",
        columns: [],
        chartSettings: {
          legendName: { ...mapping },
          radius: 80,
          offsetY: "50%",
        }
      },
      data: []
    };
  },
  watch: {
    condition: {
      handler (val) {
        this.data = val;
        this.chartConfig.columns = [
          'gender',
          'impressionsPercentage'
        ]
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 改变排序字段
    change (val) {
      this.selectVal = val;
      this.selectName = audienceReportRatio.find(item => item.value === val).label
      this.chartConfig.columns = ['gender', val + 'Percentage']
    },
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
